module.exports = __webpack_public_path__ + "assets/b90.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b90.png
// module id = 683
// module chunks = 0